import axios from 'axios';
import { Platform } from 'react-native';
const API = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'applicationName': Platform.OS === 'web' ? 'servicing-portal' : 'mobile-app'
  }
});
const ApiLogger = async (logEvent, config) => {
  const startTime = Date.now();
  try {
    logEvent({
      action: 'APIRequest',
      correlationId: config.headers ? config.headers['x-correlation-id'].toString() : '',
      type: 'API',
      request: config.url
    });
    const {
      data
    } = await API.request(config);
    logEvent({
      action: 'APIResponse',
      correlationId: config.headers ? config.headers['x-correlation-id'].toString() : '',
      type: 'API',
      request: config.url,
      responseTime: (Date.now() - startTime).toString(),
      success: 'true'
    });
    return Promise.resolve(data);
  } catch (e) {
    const error = e;
    let message = error === null || error === void 0 ? void 0 : error.message;
    if (error && error.response && error.response.data) {
      const {
        response: {
          data: {
            errorDetails
          }
        }
      } = error;
      if (Array.isArray(errorDetails) && errorDetails.length) {
        message = errorDetails[0] ? errorDetails[0].message : 'NA';
      }
    }
    logEvent({
      action: 'APIResponse',
      correlationId: config.headers ? config.headers['x-correlation-id'].toString() : '',
      type: 'API',
      request: config.url,
      responseTime: (Date.now() - startTime).toString(),
      success: 'false',
      error: message ? message : 'NA'
    });
    return Promise.reject(message);
  }
};
export let IStatus = /*#__PURE__*/function (IStatus) {
  IStatus["fulfilled"] = "fulfilled";
  IStatus["rejected"] = "rejected";
  return IStatus;
}({});
const AllSettled = promiseList => {
  return Promise.all(promiseList.map(promise => {
    return promise.then(value => ({
      status: IStatus.fulfilled,
      value
    })).catch(value => ({
      status: IStatus.rejected,
      value
    }));
  }));
};
export { API, ApiLogger, AllSettled };
//# sourceMappingURL=index.js.map